import { Styles } from './app/theme/materialTheme';

export const loaderContainer: Styles = {
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
};
